import $ from "jquery";

export class FileInput
{
	/**
	 * @private
	 * @type {JQuery}
	 */
	$input;

	/**
	 * @private
	 * @type {JQuery}
	 */
	$label;


	/**
	 * @param {HTMLElement} container
	 */
	constructor (container)
	{
		const $container = $(container);

		this.$input = $container.find(":file");
		this.$label = $container.find(".custom-file-label");
	}


	/**
	 *
	 */
	init ()
	{
		this.$input.on("change", () => this.onChange());
	}


	/**
	 * Callback on when the file input changes
	 *
	 * @private
	 */
	onChange ()
	{
		const value = this.$input.val().replace("C:\\fakepath\\", "");
		this.$label.text(value);
	}
}
